import React from 'react'
import { ReactComponent as BagIcon } from 'assets/icons/bag-line.svg'
import { ReactComponent as PlanetIcon } from 'assets/icons/planet.svg'
import { ReactComponent as CapIcon } from 'assets/icons/cap.svg'
import CareerRecommendationCard from './CareerRecommendationCard'
import CountryRecommendationCard from './CountryRecommendationCard'
import CourseRecommendationCard from './CourseRecommendationCard'
import UniversityRecommendationCard from './UniversityRecommendationCard'
import s from './styles/RecommendationAttachment.module.scss'

const BLOCK_META = {
	careers: {
		title: 'Recommended careers',
		Icon: BagIcon,
		Card: CareerRecommendationCard,
	},
	countries: {
		title: 'Recommended countries',
		Icon: PlanetIcon,
		Card: CountryRecommendationCard,
	},
	courses: {
		title: 'Recommended courses',
		Icon: CapIcon,
		Card: CourseRecommendationCard,
	},
	universities: {
		title: 'Recommended universities',
		Icon: CapIcon,
		Card: UniversityRecommendationCard,
	},
}

/**
 * Renders recommendation cards from structured metadata.blocks.
 * Used by SendRecommendationModal Preview and Consultant Chat.
 */
export default function RecommendationAttachment({ blocks = [], className = '' }) {
	if (!Array.isArray(blocks) || blocks.length === 0) return null

	return (
		<div className={`${s.root} ${className}`.trim()}>
			{blocks.map((block, blockIndex) => {
				const meta = BLOCK_META[block?.type]
				if (!meta || !Array.isArray(block.items) || block.items.length === 0) {
					return null
				}
				const { title, Icon, Card } = meta
				return (
					<div key={`${block.type}-${blockIndex}`} className={s.block}>
						<div className={s.blockTitle}>
							<Icon className={s.blockIcon} />
							{title}
						</div>
						<div className={s.items}>
							{block.items.map((item, itemIndex) => (
								<Card
									key={item?.id || `${block.type}-${itemIndex}`}
									item={item}
								/>
							))}
						</div>
					</div>
				)
			})}
		</div>
	)
}
